import { granularityLookup } from './granularity-lookup';

interface CalculateMeterValueProps {
  value: number;
  metric: 'demandSupply' | 'timeToFill' | 'wageGrowth' | 'marketTightness';
}

const calculateZScore = ({ value, metric }: CalculateMeterValueProps) => {
  if (metric === 'marketTightness') {
    return 0;
  }

  const zScoreComponents = granularityLookup[metric];

  const zScore = (() => {
    const mean = zScoreComponents.mean;
    const std = zScoreComponents.std;

    return (value - mean) / std;
  })();

  return zScore;
};

export const calculateMeterValue = ({
  value,
  metric,
}: CalculateMeterValueProps) => {
  const zScoreComponents = granularityLookup[metric];
  const lookup = zScoreComponents.lookup;

  const zScore = (() => {
    if (metric === 'marketTightness') {
      return value;
    }

    return calculateZScore({ value, metric });
  })();

  // Find the closest z_score and corresponding percentile from the JSON data
  const closestZScore = lookup.reduce((prev, curr) =>
    Math.abs(curr.z_score - zScore) < Math.abs(prev.z_score - zScore)
      ? curr
      : prev
  );

  return closestZScore.percentile;
};

interface CalculateMarketTightnessMeterValueProps {
  wageGrowth: number;
  demandSupply: number;
  timeToFill: number;
}
export const calculateMarketTightnessMeterValue = ({
  wageGrowth,
  demandSupply,
  timeToFill,
}: CalculateMarketTightnessMeterValueProps) => {
  const wageZscore = calculateZScore({
    value: wageGrowth,
    metric: 'wageGrowth',
  });

  const demandSupplyZscore = calculateZScore({
    value: demandSupply,
    metric: 'demandSupply',
  });

  const timeToFillZscore = calculateZScore({
    value: timeToFill,
    metric: 'timeToFill',
  });

  const marketTightnessZScore =
    0.4 * demandSupplyZscore + 0.4 * timeToFillZscore + 0.2 * wageZscore;

  return calculateMeterValue({
    value: marketTightnessZScore,
    metric: 'marketTightness',
  });
};
